// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__2r3I8","popup":"styles_popup__3xR_R","content":"styles_content__3TXmF","close":"styles_close__K0I0e","buttonAccept":"styles_buttonAccept__1-jcK"};